import { useEffect, useCallback } from 'react';
import { Drawer, Form, message } from 'antd';
import MD5 from 'crypto-js/md5';

import request from '@/request';
import InputItem from '../../components/InputItem';
import SaveButton from '../../components/SaveButton';

export default function EditDrawer({ open, onClose, onSave }) {
  const [form] = Form.useForm();
  const nameVal = Form.useWatch('name', form);
  const phoneVal = Form.useWatch('phone', form);
  const passwordVal = Form.useWatch('password', form);
  const confirmPasswordVal = Form.useWatch('confirmPassword', form);

  useEffect(() => {
    if (!open) {
      // 关闭时重置表单
      form.resetFields();
    }
  }, [open, form]);

  const onConfirm = useCallback(async () => {
    try {
      const values = await form.validateFields();

      // 校验密码一致性
      if (values.password !== values.confirmPassword) {
        message.error('两次输入的密码不一致');
        return;
      }

      // 校验手机号格式
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(values.phone)) {
        message.error('请输入有效的手机号');
        return;
      }

      await request.post(
        '/events/org/sub/account',
        {
          name: values.name,
          phone: values.phone,
          password: MD5(String(values.password).trim()).toString(),
        },
        {
          headers: {
            role: 5,
          },
        }
      );

      message.success('子账户创建成功');
      onSave?.();
      onClose();
    } catch (error) {
      // Form validation errors are already handled by antd
    }
  }, [form, onClose, onSave]);

  return (
    <Drawer
      title="创建子账户"
      size={400}
      onClose={onClose}
      open={open}
      extra={<SaveButton text="保存" onSave={onConfirm} />}
    >
      <Form form={form} layout="vertical">
        <div className="space-y-4">
          <Form.Item
            name="name"
            rules={[
              { required: true, message: '请输入账户名称' },
              { min: 2, message: '账户名称至少2个字符' },
              { max: 20, message: '账户名称不超过20个字符' },
            ]}
          >
            <InputItem
              label="账户名称"
              placeholder="请输入账户名称"
              value={nameVal}
              onChange={(v) => form.setFieldsValue({ name: v })}
              require
            />
          </Form.Item>

          <Form.Item
            name="phone"
            rules={[
              { required: true, message: '请输入手机号' },
              {
                pattern: /^1[3-9]\d{9}$/,
                message: '请输入有效的手机号',
              },
            ]}
          >
            <InputItem
              label="手机号"
              placeholder="请输入手机号"
              value={phoneVal}
              maxLength={11}
              onChange={(v) => form.setFieldsValue({ phone: v })}
              require
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: '请输入密码' },
              { min: 6, message: '密码至少6个字符' },
              { max: 20, message: '密码不超过20个字符' },
            ]}
          >
            <InputItem
              label="密码"
              placeholder="请输入密码"
              type="password"
              value={passwordVal}
              onChange={(v) => form.setFieldsValue({ password: v })}
              require
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            rules={[{ required: true, message: '请确认密码' }]}
          >
            <InputItem
              label="确认密码"
              placeholder="请再次输入密码"
              type="password"
              value={confirmPasswordVal}
              onChange={(v) => form.setFieldsValue({ confirmPassword: v })}
              require
            />
          </Form.Item>
        </div>
      </Form>
    </Drawer>
  );
}
